<script setup lang="ts">
const platformStore = usePlatformStore();
</script>

<template>
  <a
    :href="platformStore.getCustomerSupportLink"
    target="_blank"
    rel="noopener noreferrer"
  >
    <slot />
  </a>
</template>
